/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import vuetify from './vuetify';

import VueSession from "vue-session";
Vue.use(VueSession);

import IdleVue from "idle-vue";
import Vuex from "vuex";
import "export-json-excel";


Vue.config.productionTip = false;



window.Vue = require('vue').default;




/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


 Vue.component('loading-spin', require('./components/Spin.vue').default);
 Vue.component('app-message', require('./components/AppMessage.vue').default);
 Vue.component('app-currency',require('./components/Currency.vue').default);
 Vue.component('new-firma',require('./components/NewFirma.vue').default);
 Vue.component('kh-nakladnoy',require('./components/Kh_nakladnoy.vue').default);
 Vue.component('new-mol',require('./components/NewMol.vue').default);
 Vue.component('new-klent', require('./components/NewKlent.vue').default);
 Vue.component('o-smena', require('./components/o_smena.vue').default);
 Vue.component('priyom-smena-all', require('./components/PriyomSmena/PriyomSmenaAll.vue').default);
 Vue.component('priyom-smena-opened', require('./components/PriyomSmena/PriyomSmenaOpened.vue').default);
 Vue.component('priyom-smena-closed', require('./components/PriyomSmena/PriyomSmenaClosed.vue').default);
 Vue.component('priyom-smena-accepted', require('./components/PriyomSmena/PriyomSmenaAccepted.vue').default);
 Vue.component('bist-menu', require('./components/Settings/BistMenu.vue').default);
 Vue.component('users', require('./components/Settings/Users.vue').default);
 Vue.component('klents-card', require('./components/KlentsCard.vue').default);
 Vue.component('partners-card', require('./components/PartnersCard.vue').default);
 Vue.component('new-klent', require('./components/NewKlent.vue').default);
 Vue.component('new-partner', require('./components/NewPartner.vue').default);
 Vue.component('bonus-card', require('./components/BonusCard.vue').default);

 Vue.component('v-magazin', require('./components/Moving/V_Magazin.vue').default);
 Vue.component('v-sklad', require('./components/Moving/V_Sklad.vue').default);
 Vue.component('molho', require('./components/Moving/Molho.vue').default);

 Vue.component('po-chekam', require('./components/O_prodaja/PoChekam.vue').default);
 Vue.component('po-tovarov', require('./components/O_prodaja/PoTovarov.vue').default);
 Vue.component('o-peremeshenie', require('./components/Moving/O_Peremeshenie.vue').default);
 Vue.component('o-peremeshenie-nasklad', require('./components/Moving/O_Peremeshenie_naslad.vue').default);
 Vue.component('o-vozvrat_po_chekam', require('./components/O_Vozvrat/Vozvrat_po_chekam.vue').default);
 Vue.component('o-vozvrat_po_tovarov', require('./components/O_Vozvrat/Vozvrat_po_tovarov.vue').default);
 Vue.component('o-vozvrat-firma', require('./components/O_Vozvrat/VozvratFirma.vue').default);
 Vue.component('o-klent', require('./components/O_Klent/o_klent.vue').default);
 Vue.component('karzdoron', require('./components/O_Klent/karzdoron.vue').default);
 Vue.component('dolgoviki', require('./components/O_Klent/dolgoviki.vue').default);
 Vue.component('history', require('./components/O_Klent/history.vue').default);
 Vue.component('o-firma', require('./components/O_Firma/o_firma.vue').default);
 Vue.component('karzi-mo', require('./components/O_Firma/karzi_mo.vue').default);
 Vue.component('dolgi-firma', require('./components/O_Firma/dolgi_firma.vue').default);
 Vue.component('o-kassa-dokhod', require('./components/O_Kassa/o_kassa_dokhod.vue').default);
 Vue.component('o-kassa-raskhod', require('./components/O_Kassa/o_kassa_raskhod.vue').default);
 Vue.component('o-kassa-firma', require('./components/O_Kassa/o_kassa_firma.vue').default);
 Vue.component('ostatok-kassa', require('./components/O_Kassa/ostatok_kassa.vue').default);
 Vue.component('dds', require('./components/O_Kassa/dds.vue').default);
 Vue.component('o-pokupka-chekam', require('./components/O_Pokupka/o_pokupka_chek.vue').default);
 Vue.component('o-pokupka-tovar', require('./components/O_Pokupka/o_pokupka_tovar.vue').default);

 Vue.component('sklad-tovar', require('./components/Tovar/Sklad.vue').default);
 Vue.component('magazin-tovar', require('./components/Tovar/Magoza.vue').default);
 Vue.component('spisanie-tovar', require('./components/Tovar/Spisanie.vue').default);
 Vue.component('minimum', require('./components/Tovar/Minimum.vue').default);
 Vue.component('srok', require('./components/Tovar/Srok.vue').default);
 Vue.component('dvizhenie-tovar-magazin', require('./components/Tovar/Dvizhenie_magazin.vue').default);
 Vue.component('dvizhenie-tovar-sklad', require('./components/Tovar/Dvizhenie_sklad.vue').default);
 Vue.component('balans', require('./components/balans.vue').default);
 Vue.component('pribil-toza', require('./components/Pribil_toza.vue').default);

 Vue.component('o-rabota-smena', require('./components/O_Kassa/o_rabota_smena.vue').default);
 Vue.component('obnalichka', require('./components/obnalichka.vue').default);
 Vue.component('zametka', require('./components/zametka.vue').default);
 Vue.component('toza-pribil', require('./components/toza_pribil.vue').default);

 Vue.component('bonus-omad', require('./components/O_Bonus/Bonus_omad.vue').default);
 Vue.component('bonus-raft', require('./components/O_Bonus/Bonus_raft.vue').default);
 Vue.component('bonus-mond', require('./components/O_Bonus/Bonus_mond.vue').default);

 Vue.component('visits', require('./components/Visits.vue').default);


 Vue.component('ModalIdle', require('./components/ModalIdle.vue').default);

 Vue.component('vueInternetChecker', require('vue-internet-checker'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 import VueApexCharts from 'vue-apexcharts'
 Vue.use(VueApexCharts)

 import excel from 'vue-excel-export'

Vue.use(excel)

 Vue.component('apexchart', VueApexCharts)


import router from "./router";
import Vue from 'vue';
import store from './store';
import moment from 'moment'


Vue.use(IdleVue, {
  eventEmitter: app,
  store,
  idleTime: 600000 * 60,
  startAtIdle: false,



  events: [
    "mousemove",
    "keydown",
    "mousedown",
    "touchstart",
    "touchmove",
    "mousewheel"
  ]
});



const app = new Vue({
    el: '#app',
    router,
    vuetify,
    store,
    moment,








    render: h => h(require('./App.vue').default)
});
